//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import shopTagsMetricsModule from '@instagram-account/instagram-account-shop-tags-metrics/shop-tags-metrics-module';
import angular from 'angular';
import analyticsAtAGlanceModule from 'app/analytics-at-a-glance/analytics-at-a-glance.module';
import promotedPostsMetricsModule from 'app/promoted-posts-metrics/promoted-posts-metrics-module';
import promotedPostsModule from 'app/promoted-posts/promoted-posts-module';

export default angular.module('curalate.instagram-account.app', [
  'curalate',
  'highcharts-ng',
  promotedPostsModule.name,
  promotedPostsMetricsModule.name,
  shopTagsMetricsModule.name,
  analyticsAtAGlanceModule.name,
]);
